import React from 'react';

// ReactHtmlParser takes a transform function:
// https://www.npmjs.com/package/react-html-parser#transform-function
//
// This implements a function that replaces anchor tags with spans.
//
// Rendering nested anchor tags is invalid html and can cause the hydration
// phase of server side rendering to throw errors.
const transformLinksToSpans = (node, index) => {
  if (node.type === 'tag' && node.name === 'a') {
    return <span key={index}>{node.children[0].data}</span>;
  }

  return undefined;
};

export { transformLinksToSpans };
